<template>
  <div class="checkbox-wrapper text-shadow">
    <Checkbox
      :id="name"
      v-bind="$attrs"
      :name="name"
      v-model="modelValue"
      :class="{
        'border-destructive': error,
      }"
    />
    <Label :for="name" :class="error && 'text-destructive'" class="ml-1 text-balance text-xs">{{
      label
    }}</Label>
  </div>
  <span class="input-error" v-if="error">{{ error }}</span>
</template>

<script setup lang="ts">
import Checkbox from '@ui/checkbox/Checkbox.vue';
import Label from '@ui/label/Label.vue';

interface CheckboxProps {
  label: string;
  name: string;
  error?: string;
}

withDefaults(defineProps<CheckboxProps>(), {
  error: undefined,
});

const modelValue = defineModel<boolean>('modelValue', {
  required: true,
});
</script>
